const Radio = {
  defaultProps: {
    colorScheme: 'primary',
  },
};

export default Radio;
